<template>
  <div class="ruller-form-control">
    <div class="ruller-prop-control-section">
      <div class="ruller-prop-control-section-header">Юниты</div>
      <div class="ruller-prop-control-section-row">
        <div class="ruller-prop-control-select-wrapper">
          <select v-model="unit">
            <template
              v-for="unit in allUnits"
              :key="unit.id"
            >
              <option :value="unit.id">{{ translateUnitName(unit) }}</option>
            </template>
          </select>
        </div>
      </div>
      <label
        :for="instanceId + 'rullerColor'"
        class="ruller-prop-control-section-header"
        >Цвет линейки</label
      >
      <div class="ruller-prop-control-section-row">
        <div
          class="ruller-prop-control-input-wrapper ruller-prop-control-input-wrapper-color"
        >
          <input
            type="color"
            v-model="rullerColor"
            :id="instanceId + 'rullerColor'"
          />
          <input
            type="text"
            v-model="rullerAlpha"
            @change="onc_rullerAlpha"
            @wheel="onwheelra($event)"
          />
        </div>
      </div>
      <div style="display: none">
        <label
          :for="instanceId + 'rullerWidth'"
          class="ruller-prop-control-section-header"
          >Толщина линейки</label
        >
        <div class="ruller-prop-control-section-row">
          <div class="ruller-prop-control-input-wrapper">
            <input
              type="text"
              v-model="rullerWidth"
              :id="instanceId + 'rullerWidth'"
              @change="onc_rullerWidth"
              @wheel="onwheelrw($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="ruller-prop-control-section">
      <div class="ruller-prop-control-checkbox">
        <input
          type="checkbox"
          v-model="showGrid"
          :id="instanceId + 'showGrid'"
        />
        <label
          :for="instanceId + 'showGrid'"
          class="ruller-prop-control-section-header"
          >Сетка</label
        >
      </div>
      <div class="ruller-prop-control-section-row">
        <div
          class="ruller-prop-control-section-row-split ruller-prop-control-section-row-split-75"
        >
          <div class="ruller-prop-control-input-wrapper">
            <input
              type="text"
              v-model="gridStepFMT"
              :id="instanceId + 'gridStep'"
              @change="onc_gridStep"
            />
          </div>
        </div>
        <div
          class="ruller-prop-control-section-row-split ruller-prop-control-section-row-split-25"
        >
          <div
            class="ruller-prop-control-select-wrapper ruller-prop-control-select-wrapper-no-left-border"
          >
            <select v-model="gridUnit">
              <template
                v-for="unit in allUnits"
                :key="unit.id"
              >
                <option :value="unit.id">{{ translateUnitName(unit) }}</option>
              </template>
            </select>
          </div>
        </div>
      </div>
      <label
        :for="instanceId + 'xoffset'"
        class="ruller-prop-control-section-header"
        >Смещение</label
      >
      <div class="ruller-prop-control-section-row">
        <div class="ruller-prop-control-input-wrapper">
          <label
            :for="instanceId + 'xoffset'"
            class="ruller-prop-control-input-wrapper-label"
            >X</label
          >
          <input
            type="text"
            v-model="gridOffsetXFMT"
            :id="instanceId + 'xoffset'"
            @change="onc_gridOffsetX"
            @wheel="onwheels($event, 'x')"
          />
          <div
            class="ruller-prop-control-do-calibrate"
            @click="clearOffset('x')"
          >
            <svg><use xlink:href="#ruller-control-icon-cross" /></svg>
          </div>
        </div>
      </div>
      <div class="ruller-prop-control-section-row ruller-prop-margin-top-05">
        <div class="ruller-prop-control-input-wrapper">
          <label
            :for="instanceId + 'yoffset'"
            class="ruller-prop-control-input-wrapper-label"
            >Y</label
          >
          <input
            type="text"
            v-model="gridOffsetYFMT"
            :id="instanceId + 'yoffset'"
            @change="onc_gridOffsetY"
            @wheel="onwheels($event, 'y')"
          />
          <div
            class="ruller-prop-control-do-calibrate"
            @click="clearOffset('y')"
          >
            <svg><use xlink:href="#ruller-control-icon-cross" /></svg>
          </div>
        </div>
      </div>
      <label
        :for="instanceId + 'color'"
        class="ruller-prop-control-section-header"
        >Цвет</label
      >
      <div class="ruller-prop-control-section-row">
        <div
          class="ruller-prop-control-input-wrapper ruller-prop-control-input-wrapper-color"
        >
          <input
            type="color"
            v-model="gridColor"
            :id="instanceId + 'color'"
          />
          <input
            type="text"
            v-model="gridAlpha"
            @change="onc_gridAlpha"
            @wheel="onwheela($event)"
          />
        </div>
      </div>
    </div>
    <div class="ruller-prop-control-section">
      <div class="ruller-prop-control-section-header">Калибровка</div>
      <div class="ruller-prop-control-section-row">
        <div class="ruller-prop-calibration-row">
          <div class="ruller-prop-calibration-row-l1">
            <label :for="instanceId + 'xcal'">X</label>
            <input
              type="text"
              v-model="xPcuValFMT"
              :id="instanceId + 'xcal'"
              readonly="readonly"
            /><label :for="instanceId + 'kx'">pcu</label>
          </div>
          <div class="ruller-prop-calibration-equal-sign">=</div>
          <div class="ruller-prop-calibration-row-l2">
            <input
              type="text"
              v-model="xKFMT"
              :id="instanceId + 'kx'"
              @change="onc_xk"
            />
            <div class="ruller-prop-control-select-wrapper">
              <select v-model="xUnit">
                <template
                  v-for="unit in allUnits"
                  :key="unit.id"
                >
                  <option :value="unit.id">
                    {{ translateUnitName(unit) }}
                  </option>
                </template>
              </select>
            </div>
            <div
              class="ruller-prop-control-do-calibrate"
              @click="runCalibration()"
            >
              <svg><use xlink:href="#ruller-control-arrow-left-right" /></svg>
            </div>
          </div>
        </div>
      </div>
      <div class="ruller-prop-calibration-dimension-divider"></div>
      <div class="ruller-prop-control-section-row">
        <div class="ruller-prop-calibration-row">
          <div class="ruller-prop-calibration-row-l1">
            <label :for="instanceId + 'ycal'">Y</label>
            <input
              type="text"
              v-model="yPcuValFMT"
              :id="instanceId + 'ycal'"
              readonly="readonly"
            />
            <label :for="instanceId + 'ky'">pcu</label>
          </div>
          <div class="ruller-prop-calibration-equal-sign">=</div>
          <div class="ruller-prop-calibration-row-l2">
            <input
              type="text"
              v-model="yKFMT"
              :id="instanceId + 'ky'"
              @change="onc_yk"
            />
            <div class="ruller-prop-control-select-wrapper">
              <select v-model="yUnit">
                <template
                  v-for="unit in allUnits"
                  :key="unit.id"
                >
                  <option :value="unit.id">
                    {{ translateUnitName(unit) }}
                  </option>
                </template>
              </select>
            </div>
            <div
              class="ruller-prop-control-do-calibrate"
              @click="runCalibration()"
            >
              <svg><use xlink:href="#ruller-control-arrow-up-down" /></svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ruller-prop-control-section">
      <label
        :for="instanceId + 'gridStep'"
        class="ruller-prop-control-section-header"
        >Снап</label
      >
      <div class="ruller-prop-control-section-row">
        <div class="ruller-prop-control-select-wrapper">
          <select v-model="snap">
            <option value="none">Нет</option>
            <option value="node">Узел</option>
            <option value="center">Центр</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.ruller-form-control {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: auto;
  .ruller-prop-control-section {
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 1em;
    padding-bottom: 1em;
    border-bottom: 1px solid silver;
  }
  .ruller-prop-control-section-header {
    box-sizing: border-box;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 0.5em;
    padding-left: 0.25em;
  }
  .ruller-prop-control-section-row {
    box-sizing: border-box;
    padding: 0 0.25em;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    .ruller-prop-control-section-row-split {
      box-sizing: border-box;
      overflow: hidden;
      &.ruller-prop-control-section-row-split-5 {
        width: 5%;
        max-width: 5%;
        min-width: 5%;
      }
      &.ruller-prop-control-section-row-split-10 {
        width: 10%;
        max-width: 10%;
        min-width: 10%;
      }
      &.ruller-prop-control-section-row-split-15 {
        width: 15%;
        max-width: 15%;
        min-width: 15%;
      }
      &.ruller-prop-control-section-row-split-20 {
        width: 20%;
        max-width: 20%;
        min-width: 20%;
      }
      &.ruller-prop-control-section-row-split-25 {
        width: 25%;
        max-width: 25%;
        min-width: 25%;
      }
      &.ruller-prop-control-section-row-split-30 {
        width: 30%;
        max-width: 30%;
        min-width: 30%;
      }
      &.ruller-prop-control-section-row-split-33 {
        width: 33.33333%;
        max-width: 33.33333%;
        min-width: 33.33333%;
      }
      &.ruller-prop-control-section-row-split-35 {
        width: 35%;
        max-width: 35%;
        min-width: 35%;
      }
      &.ruller-prop-control-section-row-split-40 {
        width: 40%;
        max-width: 40%;
        min-width: 40%;
      }
      &.ruller-prop-control-section-row-split-45 {
        width: 45%;
        max-width: 45%;
        min-width: 45%;
      }
      &.ruller-prop-control-section-row-split-50 {
        width: 50%;
        max-width: 50%;
        min-width: 50%;
      }
      &.ruller-prop-control-section-row-split-55 {
        width: 55%;
        max-width: 55%;
        min-width: 55%;
      }
      &.ruller-prop-control-section-row-split-60 {
        width: 60%;
        max-width: 60%;
        min-width: 60%;
      }
      &.ruller-prop-control-section-row-split-65 {
        width: 65%;
        max-width: 65%;
        min-width: 65%;
      }
      &.ruller-prop-control-section-row-split-66 {
        width: 66.66666%;
        max-width: 66.66666%;
        min-width: 66.66666%;
      }
      &.ruller-prop-control-section-row-split-70 {
        width: 70%;
        max-width: 70%;
        min-width: 70%;
      }
      &.ruller-prop-control-section-row-split-75 {
        width: 75%;
        max-width: 75%;
        min-width: 75%;
      }
      &.ruller-prop-control-section-row-split-80 {
        width: 80%;
        max-width: 80%;
        min-width: 80%;
      }
      &.ruller-prop-control-section-row-split-85 {
        width: 85%;
        max-width: 85%;
        min-width: 85%;
      }
      &.ruller-prop-control-section-row-split-90 {
        width: 90%;
        max-width: 90%;
        min-width: 90%;
      }
      &.ruller-prop-control-section-row-split-95 {
        width: 95%;
        max-width: 95%;
        min-width: 95%;
      }
      &.ruller-prop-control-section-row-split-100 {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
      }
    }
    &.ruller-prop-margin-top-05 {
      margin-top: 0.5em;
    }
  }
  .ruller-prop-control-select-wrapper {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid silver;
    position: relative;
    height: 2em;
    &:after {
      content: '\25bc';
      width: 1em;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      color: dimgray;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }
    select {
      margin: 0;
      padding: 0 0.25em;
      width: 100%;
      height: 100%;
      outline: none;
      border: none;
      cursor: pointer;
      background: transparent;
      background: rgba(0, 0, 0, 0);
      appearance: none;
      font-size: 14px;
    }
    &.ruller-prop-control-select-wrapper-no-left-border {
      border-left: none;
    }
  }
  .ruller-prop-control-input-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 2em;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    input[type='text'],
    input[type='number'] {
      width: 100%;
      box-sizing: border-box;
      height: 100%;
      font-size: inherit;
      box-shadow: none;
      outline: none;
      padding: 0 0.25em;
      margin: 0;
      border: 1px solid silver;
      text-align: right;
      &:focus {
        box-shadow: none;
        outline: none;
      }
    }

    label {
      width: 2em;
      height: 100%;
      min-width: 2em;
      max-width: 2em;
      border: 1px solid silver;
      border-right: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: inherit;
      box-sizing: border-box;
    }

    .ruller-prop-control-do-calibrate {
      box-sizing: border-box;
      width: 2em;
      height: 100%;
      overflow: hidden;
      min-width: 2em;
      max-width: 2em;
      border: 1px solid silver;
      border-left: none;
      padding: 0.4em;
      cursor: pointer;
      svg {
        width: 100%;
        height: 100%;
        fill: crimson;
        pointer-events: none;
      }
    }
    &.ruller-prop-control-input-wrapper-color {
      input[type='color'] {
        box-sizing: border-box;
        width: 24%;
        min-width: 25%;
        max-width: 25%;
        margin: 0;
        padding: 0;
        outline: none;
        border: 1px solid silver;
        border-radius: 0;
        height: 100%;
        border-right: none;
        cursor: pointer;
      }
    }
  }
  .ruller-prop-calibration-dimension-divider {
    height: 1.5em;
  }
  .ruller-prop-calibration-row {
    width: 100%;
    .ruller-prop-calibration-equal-sign {
      text-align: center;
      font-weight: bold;
      user-select: none;
    }

    .ruller-prop-calibration-row-l1 {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      height: 2em;
      width: 100%;
      label {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-weight: bold;
        font-family: inherit;
        border: 1px solid silver;
        &:nth-child(1) {
          min-width: 2em;
          width: 2em;
          border-right: none;
          max-width: 2em;
        }
        &:nth-last-child(1) {
          width: 2.5em;
          max-width: 2.5em;
          min-width: 2.5em;
          border-left: none;
        }
      }
      input[type='text'] {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 1px solid silver;
        box-shadow: none;
        border-radius: 0;
        outline: none;
        margin: 0;
        padding: 0 0.25em;
        text-align: right;
      }
    }
    .ruller-prop-calibration-row-l2 {
      box-sizing: border-box;
      width: 100%;
      height: 2em;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      input[type='text'] {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0 0.25em;
        border: 1px solid silver;
        outline: none;
        box-shadow: none;
        border-radius: 0;
        text-align: right;
      }
      .ruller-prop-control-select-wrapper {
        border-left: none;
        width: 25%;
        min-width: 25%;
      }
      .ruller-prop-control-do-calibrate {
        box-sizing: border-box;
        width: 2em;
        height: 100%;
        min-width: 2em;
        max-width: 2em;
        overflow: hidden;
        cursor: pointer;
        border: 1px solid silver;
        border-left: none;
        padding: 0.3em;
        user-select: none;
        svg {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          stroke: black;
          pointer-events: none;
        }
      }
    }
  }
}

.ruller-prop-control-checkbox {
  box-sizing: border-box;
  padding: 0.25em 0;
  input[type='checkbox'] {
    display: none;
    & + label {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      &:before {
        content: '';
        display: block;
        box-sizing: border-box;
        width: 1.25em;
        min-height: 1.25em;
        height: 1.25em;
        max-width: 1.25em;
        outline: 1px solid #00acc8;
        margin-right: 0.5em;
        outline-offset: 0;
      }
    }
    &:checked {
      & + label {
        &:before {
          border: 1px solid white;
          background: #00acc8;
        }
      }
    }
  }
}
</style>
<script>
import U from '@/lib/vendor/eve/lib-utils'
import libUnits from '@/lib/vendor/eve/lib-units'
import format from '@/lib/vendor/eve/lib-format'
import { central_data } from '@/lib/vendor/eve/planhub/lib-central-data'
import events from '@/lib/vendor/eve/planhub/lib-events'
import Filter from '@/lib/vendor/eve/lib-filter'

var allowedUnits = {
  cm: true,
  m: true,
  mm: true,
}

var unitNames = {
  cm: 'см',
  m: 'м',
  mm: 'мм',
}

// eslint-disable-next-line
var unitMap = {
  sm: 'cm',
  cm: 'cm',
  см: 'cm',
  mm: 'mm',
  мм: 'mm',
  m: 'm',
  м: 'm',
}

function install_images() {
  var d = document.getElementById('ruller-control-images')
  if (!d) {
    d = document.createElement('div')
    d.id = 'ruller-control-images'
    d.style.display = 'none'
    var ca = [
      require('!!raw-loader!@/svg/ruller/arrow-left-right.svg').default.replace(
        '<id-attribute>',
        'ruller-control-arrow-left-right',
      ),
      require('!!raw-loader!@/svg/ruller/arrow-up-down.svg').default.replace(
        '<id-attribute>',
        'ruller-control-arrow-up-down',
      ),
      require('!!raw-loader!@/svg/ruller/cross.svg').default.replace(
        '<id-attribute>',
        'ruller-control-icon-cross',
      ),
    ]
    d.innerHTML = ca.join('')
    var bs = document.getElementsByTagName('body')
    if (bs.length) {
      bs[0].appendChild(d)
    }
  }
}

function get_default_data() {
  return {
    instanceId: ['a', U.get_uuid().replace(/-/g, ''), '_'].join(''),
    allUnits: libUnits
      .F()
      .domain('linear')
      .list(function (x) {
        return Object.prototype.hasOwnProperty.call(allowedUnits, x.id)
      }),
    unit: 'mm',
    showGrid: false,
    gridStep: null,
    gridUnit: 'mm',
    gridOffsetX: 0.0,
    gridOffsetY: 0.0,
    gridColor: '#000000',
    gridAlpha: 255,
    xPcuVal: 0.0,
    xK: 0.0,
    xUnit: 'mm',
    yPcuVal: 0.0,
    yK: 0.0,
    yUnit: 'mm',
    snap: 'none',
    vposx: 50,
    vposy: 50,
    hposx: 50,
    hposy: 50,
    rullerColor: '#00FF00',
    rullerAlpha: 255,
    rullerWidth: 2,
  }
}

export default {
  name: 'ruller-control',
  data: function () {
    return get_default_data()
  },
  computed: {
    gridStepFMT: function () {
      return format.format_float(this.$data.gridStep, 6)
    },
    gridOffsetXFMT: function () {
      return format.format_float(this.$data.gridOffsetX, 6)
    },
    gridOffsetYFMT: function () {
      return format.format_float(this.$data.gridOffsetY, 6)
    },
    xPcuValFMT: function () {
      console.log('format.format_float(this.$data.xPcuVal, 6)', format.format_float(this.$data.xPcuVal, 6))
      return format.format_float(this.$data.xPcuVal, 6)
    },
    yPcuValFMT: function () {
      return format.format_float(this.$data.yPcuVal, 6)
    },
    xKFMT: function () {
      return format.format_float(this.$data.xK, 6)
    },
    yKFMT: function () {
      return format.format_float(this.$data.yK, 6)
    },
    hash: function () {
      var keys = [
        'unit',
        'gridStep',
        'gridUnit',
        'gridOffsetX',
        'gridOffsetY',
        'gridColor',
        'gridAlpha',
        'xPcuVal',
        'xK',
        'xUnit',
        'yPcuVal',
        'yK',
        'yUnit',
        'snap',
        'hposx',
        'hposy',
        'vposx',
        'vposy',
        'showGrid',
        'rullerColor',
        'rullerAlpha',
        'rullerWidth',
      ]
      var so = {}
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i]
        so[key] = this.$data[key]
      }
      return U.adler(JSON.stringify(so))
    },
  },
  watch: {
    hash: function (n, o) {
      console.log('hashchc:', n, o)
      if (n !== o) {
        this.on_project_save()
        central_data().lem.run(events._RULLER_PRESET_CHANGED)
      }
    },
  },
  components: {},
  props: {},
  methods: {
    translateUnitName: function (x) {
      return U.NEString(unitNames[x.id], x.name)
    },
    onc_gridStep: function (e) {
      this.$data.gridStep = U.floatMoreOr(e.target.value, 0, null)
    },
    onc_gridOffsetX: function (e) {
      this.$data.gridOffsetX = U.floatOr(e.target.value, 0)
    },
    onc_gridOffsetY: function (e) {
      this.$data.gridOffsetY = U.floatOr(e.target.value, 0)
    },
    onc_xk: function (e) {
      this.$data.xK = U.floatMoreOr(e.target.value, 0, 0)
    },
    onc_yk: function (e) {
      this.$data.yK = U.floatMoreOr(e.target.value, 0, 0)
    },
    onc_gridAlpha: function (e) {
      this.$data.gridAlpha = Math.min(
        Math.max(1, U.intMoreOr(e.target.value, 0, 0)),
        255,
      )
    },
    onc_rullerAlpha: function (e) {
      this.$data.rullerAlpha = Math.min(
        Math.max(1, U.intMoreOr(e.target.value, 0, 0)),
        255,
      )
    },
    onc_rullerWidth: function (e) {
      this.$data.rullerWidth = Math.min(
        Math.max(1, U.intMoreOr(e.target.value, 0, 0)),
        10,
      )
    },
    clearOffset: function (xy) {
      if ('x' === xy) {
        this.$data.gridOffsetX = 0.0
      } else {
        this.$data.gridOffsetY = 0.0
      }
    },
    runCalibration() {
      central_data().lem.run(events._START_RULLER_CALIBRATION, {
        hsize: U.FloatMoreOr(this.$data.xPcuVal, 0, 50),
        vsize: U.FloatMoreOr(this.$data.yPcuVal, 0, 50),
        hposx: U.FloatOr(this.$data.hposx, 50),
        hposy: U.FloatOr(this.$data.hposy, 50),
        vposx: U.FloatOr(this.$data.vposx, 50),
        vposy: U.FloatOr(this.$data.vposy, 50),
      })
    },
    on_ruller_measurement: function (e, rs) {
      var si = U.safeObject(U.safeObject(rs).size)
      this.$data.xPcuVal = U.floatMoreOr(si.h, 0, 0)
      this.$data.yPcuVal = U.floatMoreOr(si.v, 0, 0)
      var hpos = U.safeObject(U.safeObject(U.safeObject(rs).pos).h)
      this.$data.hposx = U.floatOr(hpos.x, 50)
      this.$data.hposy = U.floatOr(hpos.y, 50)
      var vpos = U.safeObject(U.safeObject(U.safeObject(rs).pos).v)
      this.$data.vposx = U.floatOr(vpos.x, 50)
      this.$data.vposy = U.floatOr(vpos.y, 50)
    },
    on_project_loaded: function (en, cd) {
      if (!U.isObject(cd.project.custom_data)) {
        cd.project.custom_data = { '__@@generated': new Date().getTime() }
      }
      if (!U.isObject(cd.project.custom_data.ruller)) {
        cd.project.custom_data.ruller = {
          '__@@generated': new Date().getTime(),
        }
      }
      U.deep_clone(cd.project.custom_data.ruller, this.$data)
      var colorStr = U.NEString(cd.project.custom_data.ruller.gridColor, '')
      var colorData = U.parse_color_obj(colorStr)
      this.$data.gridColor = colorData.html
      this.$data.gridAlpha = Math.min(
        255,
        Math.max(1, U.intMoreOr(colorData.a, 0, 255)),
      )
      // ruller color
      colorStr = U.NEString(cd.project.custom_data.ruller.rullerColor, '')
      colorData = U.parse_color_obj(colorStr)
      this.$data.rullerColor = colorData.html
      this.$data.rullerAlpha = Math.max(
        1,
        Math.min(255, U.IntMoreOr(colorData.a, 0, 255)),
      )
    },
    on_project_save: function () {
      var cd = central_data()
      if (!U.isObject(cd.project.custom_data)) {
        cd.project.custom_data = { '__@@generated': new Date().getTime() }
      }
      if (!U.isObject(cd.project.custom_data.ruller)) {
        cd.project.custom_data.ruller = {
          '__@@generated': new Date().getTime(),
        }
      }
      var data = Filter().apply_hash_xml(
        this.$data,
        require(`!!raw-loader!./validators/ruller-data.xml`).default,
        'ruller/export',
      )
      Filter().throw_bad_value(data) // no bad values
      var colorData = Filter().apply_hash_xml(
        this.$data,
        require(`!!raw-loader!./validators/ruller-data.xml`).default,
        'color/export',
      )
      data.gridColor = U.createColor(colorData.gridColor, colorData.gridAlpha)
      data.rullerColor = U.createColor(
        colorData.rullerColor,
        colorData.rullerAlpha,
      )
      cd.project.custom_data.ruller = data
    },
    onwheels: function (event, key) {
      if (event.target === document.activeElement) {
        var delta = Math.sign(event.deltaY)
        if (key === 'x') {
          this.$data.gridOffsetX =
            U.FloatOr(this.$data.gridOffsetX, 0) + delta * 0.1
        } else if (key === 'y') {
          this.$data.gridOffsetY =
            U.FloatOr(this.$data.gridOffsetY, 0) + delta * 0.1
        }
      }
    },
    onwheela: function (event) {
      if (event.target === document.activeElement) {
        var delta = Math.sign(event.deltaY)
        var cv = U.IntMoreOr(this.$data.gridAlpha, 0, 0)
        var nv = Math.max(1, Math.min(255, cv + delta))
        this.$data.gridAlpha = nv
      }
    },
    onwheelra: function (event) {
      if (event.target === document.activeElement) {
        var delta = Math.sign(event.deltaY)
        var cv = U.IntMoreOr(this.$data.rullerAplha, 0, 1)
        var nv = Math.max(1, Math.min(255, cv + delta))
        this.$data.rullerAlpha = nv
      }
    },
    onwheelrw: function (event) {
      if (event.target === document.activeElement) {
        var delta = Math.sign(event.deltaY)
        var cv = U.IntMoreOr(this.$data.rullerWidth, 0, 0)
        var nv = Math.max(1, Math.min(10, cv + delta))
        this.$data.rullerWidth = nv
      }
    },
  },
  mounted: function () {
    install_images()
  },
  created: function () {
    central_data()
      .on(
        events._PROJECT_LOAD_COMPLETE,
        this,
        this.on_project_loaded.bindTo(this),
      )
      .on(
        events._PROJECT_SAVE_CUSTOM_DATA,
        this,
        this.on_project_save.bindTo(this),
      )
      .on(events._RULLER_CALIBRATION_APPLY, this, this.on_ruller_measurement)
  },
}
</script>
